namespace $.$$ {

	$mol_style_define( $shm_service_filter_panel, {
		width: '24rem',
		flex: { basis: '24rem', grow: 0, shrink: 0 },

		Filters: {
			width: '100%',
		},
	} )

}
